import { render, staticRenderFns } from "./RadioButtonForm.vue?vue&type=template&id=36c4352d&scoped=true&"
import script from "./RadioButtonForm.vue?vue&type=script&lang=js&"
export * from "./RadioButtonForm.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonForm.vue?vue&type=style&index=0&id=36c4352d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4352d",
  null
  
)

export default component.exports